<template>
	<v-flex xs12>
		<EditTextTask v-if="taskType == 6 || taskType == 20" validate-method="checkpointsValidator/validateTextTaskEdit"></EditTextTask>
		<div>
		<!--v-container grid-list-md text-xs-center-->
			 
	 		<v-card v-for="(a, counter) in Object.keys(answers)" style="margin-bottom:2em;" :key="counter">
	 			 <v-img v-if="!answers[a].isBeingReplaced"
	 			 	:src="path + '/' + route.name + '/' + parseFile(a)"
	 			 	aspect-ratio="1"
	 			 ></v-img>
	 			 <Upload
	 			 	validate-method="checkpointsValidator/validateImageTaskEdit"
	 			 	set-valid="checkpointsValidator/setValidEdit"
	 			 	upload="files/uploadImageTaskEdit"
					button-text="Upload one image file"
					:instruction-text="`You can upload by dragging and dropping one image (${validExtensions}) file)`"
					:max-files="1"
					:validate-num-of-files="validateNumOfFiles"
	 			 	v-if="answers[a].isBeingReplaced === true && (taskType == 6 || taskType == 20)"></Upload>

	 			 	<Upload
	 			 	validate-method="checkpointsValidator/validateCameraTaskEdit"
	 			 	set-valid="checkpointsValidator/setValidEdit"
	 			 	upload="files/uploadImageTaskEdit"
					button-text="Upload one image file"
					:instruction-text="`You can upload one image (${validExtensions}) file by dropping it here`"
					:validate-num-of-files="validateNumOfFiles"
	 			 	v-if="answers[a].isBeingReplaced === true && taskType == 15"></Upload>

	 			 	

	 			 <v-btn :disabled="isBeingReplaced" flat v-if="!answers[a].isBeingReplaced" @click="setIsBeingReplaced(a)" style="margin-top:1em;" color="primary" small>
	 			 	<v-icon>backup</v-icon>
	 			 	&nbsp;
	 			 	{{translater.__('Upload', 'routes')}}
	 			 	
	 			 </v-btn>
				<v-btn flat  v-if="answers[a].isBeingReplaced" @click="cancelIsBeingReplaced(a)" style="margin-top:1em;" color="primary" small>
					<v-icon>cancel</v-icon>
					&nbsp;
					{{translater.__('Cancel')}}

				</v-btn>


	 			 <v-text-field
	 			 	@keyup="setAnswerContent($event, a)"
	 			 	:label="translater.__('Answer', 'tasks')"
	 			 	:value="answers[a].content"
	 			 >
	 			 	
	 			 </v-text-field>
	 			 

	 		</v-card>
	 		<v-card-actions>
			        	<!--v-btn :disabled="!valid" @click="update()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="() => update()"></SuccessButton>

			        	<!--v-btn @click="edit = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => edit = false"></ErrorButton>
			        </v-card-actions>
	 	</div>
	 </v-flex>
</template>

<script>

	import {parseFileName} from '../../../tools';
	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'
	
	import EditTextTask from './EditTextTask'
	import Upload from './Upload';
	import fileTools from '../../../tools/files';

	export default {
		name: 'EditImageTask',
		components: {ErrorButton, SuccessButton, EditTextTask, Upload},

		props:['validateMethod'],

		/*created()
		{
			window.vm.$on('isBeingReplaced', () => {
				this.$forceUpdate()
			})
		},*/

		computed:{

			validExtensions: {
				get()
				{
					const {validExtensions} = fileTools.getValidExtensions(this.taskType,
							this.$store.getters['files/validMimeTypes'])

					return validExtensions.join(', ')
				}
			},

			taskType: {
				get()
				{
					
					let t = this.$store.getters['checkpoints/editableTask'].type
					
					return t;
				},

				
			},

			edit:{
				get()
				{
					return this.$store.getters['checkpoints/editTask'];
				},
				set(value)
				{
					this.$store.dispatch('checkpoints/setEditTask', value)
				}

			},

			valid: {
				get()
				{
					return this.$store.getters['checkpointsValidator/isValidEdit']
				}
			},

			translater:{
				get()
				{
					return this.$store.getters['translate/translater']
				}
			},

			answers:{
				get()
				{
					let a = this.$store.getters['checkpoints/editableTask'].question.answers;

					return a;
				}
				
			},

			isUploading: {
				get()
				{
					return this.$store.getters['checkpoints/isUploading']
				}
			},

			path: {
				get()
				{	
					let p = this.$store.getters['checkpoints/fullPathEdit'];
					
					return p;
				}
			},

			route: {
				get()
				{
					return this.$store.getters['routes/route']
				}
			},

			isBeingReplaced: {
				get()
				{
					return this.$store.getters['checkpoints/isBeingReplaced'];
				}
			} 
		},

		methods: {

			validateNumOfFiles(files, cb)
			{
				let valid = false;
				if(files.length === 1)
				{
					valid = true;
				}

				cb(valid)
			},

			cancelIsBeingReplaced(name) {
				this.$store.dispatch('checkpoints/setIsBeingReplaced', {name, value: false});
			},

			parseFile(fn)
			{
				return parseFileName(fn);
			},

			setIsBeingReplaced(name)
			{

				this.$store.dispatch('checkpoints/setIsBeingReplaced', {name: name, value: true});
			},

			update()
			{
				this.$store.dispatch('checkpoints/updateTask')
			},

			setAnswerContent(e, name)
			{
				this.$store.dispatch('checkpoints/setEditableTaskAnswer', {value: {content:e.target.value}, name: name})

				this.$store.dispatch(this.validateMethod)
				.then((valid) => {
					this.$store.commit('checkpointsValidator/setValidEdit', valid)
				})
			}
		}

	}
</script>